// export const API_BASE_URL = "https://api.example.com";

const API_URL = process.env.REACT_APP_API_URL;


export const handeljobAdd = async (jobData) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}/jobs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",          // ← very important!
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobData),                 // ← convert object to JSON
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Server error: ${response.status}`);
    }

    const data = await response.json();
    return data; // should return { message: "Job created", job: {...} }
  } catch (error) {
    console.error("Job creation failed:", error);
    throw error;
  }
};


export const getAllJobs = async () => {
  try {
    // const user = JSON.parse(localStorage.getItem("user"));
    // const token = user?.token;

    // if (!token) {
    //   throw new Error("Authentication token not found. Please login again.");
    // }

    const response = await fetch(`${API_URL}/jobs`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `Failed to fetch jobs (${response.status})`
      );
    }

    const data = await response.json();
    return data; // expected: array of job objects
  } catch (error) {
    console.error("Get jobs error:", error);
    throw error;
  }
};

// api.js (add this function)

// ... existing getAllJobs, handeljobAdd ...

export const updateJob = async (jobId, updatedData) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}/jobs/${jobId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      let message =
        errorData.message ||
        (Array.isArray(errorData.errors) && errorData.errors[0]?.message) ||
        `Failed to update job (${response.status})`;

      // Make message user-friendly
      if (typeof message === "string") {
        if (message.toLowerCase().includes("deadline must be in future")) {
          message = "Application deadline must be a future date";
        }
        message = message.replace(/^Validation error:\s*/i, "");
      }

      throw new Error(message);
    }

    return await response.json();
  } catch (error) {
    console.error("Update job error:", error);
    throw error;
  }
};

export const deleteJob = async (jobId) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (!token) {
      throw new Error("Authentication token not found. Please log in again.");
    }

    const response = await fetch(`${API_URL}/jobs/${jobId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      let errorMessage = `Failed to delete job (${response.status})`;
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch {}
      throw new Error(errorMessage);
    }

    // Some APIs return { message: "Job deleted" }, others return 204 (no content)
    const data = response.status !== 204 ? await response.json() : { message: "Job deleted successfully" };
    return data;
  } catch (error) {
    console.error("Delete job error:", error);
    throw error;
  }
};


//  Submit job application with resume
 
export const submitApplication = async (applicationData) => {
    try {
        // const user = JSON.parse(localStorage.getItem("user"));
        // const token = user?.token;

        // Optional: Uncomment if you want auth for applications
        // if (!token) {
        //   throw new Error("Authentication token not found. Please login.");
        // }

        const response = await fetch(`${API_URL}/applications/v1`, {
            method: "POST",
            headers: {
                // Authorization: token ? `Bearer ${token}` : "", 
            },
            body: applicationData, // FormData (no Content-Type header)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to submit application (${response.status})`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Application submission error:", error);
        throw error;
    }
};

export const getAllApplications = async () => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const token = user?.token;

        if (!token) {
            throw new Error("Authentication token not found. Please login.");
        }

        const response = await fetch(`${API_URL}/applications`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to fetch applications (${response.status})`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Get applications error:", error);
        throw error;
    }
};


export const updateApplicationStatus = async (id, status) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (!token) {
      throw new Error("Authentication token not found. Please login.");
    }

    const response = await fetch(`${API_URL}/applications/${id}/status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `Failed to update status (${response.status})`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Update application status error:", error);
    throw error;
  }
};


export const deleteApplication = async (id) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (!token) {
      throw new Error("Authentication token not found. Please login.");
    }

    const response = await fetch(`${API_URL}/applications/${id}/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `Failed to delete application (${response.status})`
      );
    }

    // Some APIs return empty body on delete
    const data = await response.json().catch(() => ({}));
    return data;
  } catch (error) {
    console.error("Delete application error:", error);
    throw error;
  }
};
      

// ====================== CONTACT US API ======================

export const submitContactForm = async (formData) => {
    try {
        const response = await fetch(`${API_URL}/auth/contactus`, {   // ← Change if your endpoint is different
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to send message (${response.status})`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Contact form submission error:", error);
        throw error;
    }
};